import type { InstallTest, InstallTestResult, TestedDevice } from "@/.generated/hey/backoffice-backend/types.gen.ts";
import type {
  V2V5InstallationTest,
  V2V5InstallationTestResult,
  VxInstallationTest,
} from "@/domains/install-tests/installation-tests.ts";

import { brandNumber, brandString } from "@/lib/branded.ts";

function mapDate(value: string | null): Date | undefined {
  return value === null ? undefined : new Date(value);
}

export function mapVxInstallationTests(devices: ReadonlyArray<TestedDevice>): Array<VxInstallationTest> {
  return devices.map((device) => ({
    applianceName: device.applianceName ?? undefined,
    deviceType: device.deviceType ?? undefined,
    location: device.location ?? undefined,
    serialNumber: brandString(device.serialNumber) ?? undefined,
    testResults: device.testResults?.map((result) => ({
      gatewayHwId: brandNumber(result.gatewayHwId) ?? undefined,
      id: brandNumber(result.id) ?? undefined,
      isAutoTestAllowed: result.isAutoTestAllowed ?? undefined,
      isModulationOk: result.isModulationOk ?? undefined,
      measuredPower: result.measuredPower ?? undefined,
      serverReceptionDateTime: mapDate(result.serverReceptionDateTime),
      testEndGatewayDateTime: mapDate(result.testEndGatewayDateTime),
      testResult: result.testResult ?? undefined,
      testStartGatewayDateTime: mapDate(result.testStartGatewayDateTime),
    })),
  }));
}

export function mapV2V5InstallationTests(tests: ReadonlyArray<InstallTest>): Array<V2V5InstallationTest> {
  return tests.map((test) => ({
    dateSent: mapDate(test.dateSent),
    installTestId: brandNumber(test.installTestId),
    modulatorCsId: brandNumber(test.modulatorCsId) ?? undefined,
    modulatorId: brandNumber(test.modulatorId) ?? undefined,
    momboxId: brandNumber(test.momboxId) ?? undefined,
    origin: test.origin ?? undefined,
    siteId: brandNumber(test.siteId) ?? undefined,
    testerId: brandNumber(test.testerId) ?? undefined,
    testerName: test.testerName ?? undefined,
  }));
}

export function mapV2V5InstallationTestResults(
  results: ReadonlyArray<InstallTestResult>,
): Array<V2V5InstallationTestResult> {
  return results.map((result) => ({
    id: brandNumber(result.id),
    measuredPower: result.measuredPower ?? undefined,
    testResult: result.testResult ?? undefined,
    testTarget: result.testTarget ?? undefined,
  }));
}
